import React, {Suspense, useEffect} from "react";
import {Redirect, Switch, useHistory} from "react-router-dom";
import {ContentRoute, LayoutSplashScreen} from "../_metronic/layout";
import {DashboardPage} from "./pages/DashboardPage";
import {ServicesPage} from "./pages/service/ServicesPage";
import {RoomsPage} from "./pages/room/RoomsPage";
import {RoomSessionsPage} from "./pages/room/RoomSessionsPage";
import {RoomAttendancePage} from "./pages/room/RoomAttendancePage";
import {UsersPage} from "./pages/user/UsersPage";
import {SessionsPage} from "./pages/SessionsPage";
import {ConnectionsPage} from "./pages/ConnectionsPage";
import {FilesPage} from "./pages/file/FilesPage";
import {SupportsPage} from "./pages/SupportsPage";
import {FAQPage} from "./pages/FAQPage";
import {NewUserPage} from "./pages/user/NewUserPage";
import {NewRoomPage} from "./pages/room/NewRoomPage";
import {
	Provider as AlertProvider,
	positions, transitions,
} from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'
import {EditRoomPage} from "./pages/room/EditRoomPage";
import {EditUserPage} from "./pages/user/EditUserPage";
import {AddUserToRoomPage} from "./pages/room/AddUserToRoomPage";
import {PlansPage} from "./pages/plan/PlansPage";
import InvoicePage from "./pages/plan/InvoicePage";
import LibraryPage from "./pages/library/LibraryPage";
import {RecordPage} from "./pages/record/RecordPage";
import {ImportUserPage} from "./pages/user/ImportUserPage";
import {ServiceModifyPage} from "./pages/service/ServiceModifyPage";
import {NewFilePage} from "./pages/file/NewFilePage";
import {EditFilePage} from "./pages/file/EditFilePage";
import ResetPassword from "./modules/Auth/pages/ResetPassword";

export default function BasePage() {
	// useEffect(() => {
	//   console.log('Base page');
	// }, []) // [] - is required if you need only one call
	// https://reactjs.org/docs/hooks-reference.html#useeffect
	const alert_options = {
		// you can also just use 'bottom center'
		position: positions.BOTTOM_CENTER,
		timeout: 5000,
		offset: '30px',
		// you can also just use 'scale'
		transition: transitions.SCALE
	}
	const history = useHistory()

	useEffect(()=>{
		if(typeof window !=="undefined"){
			const wantPlan = window.localStorage.getItem('wantPlan')
			if(wantPlan) {
				window.localStorage.removeItem('wantPlan')
				history.push(`/plan?plan_id=${wantPlan}`);
			}
			const redirectTo = window.localStorage.getItem('redirect')
			if(redirectTo) {
				window.localStorage.removeItem('redirect')
				history.push(redirectTo);
			}
		}
	},[history.location])

	return (
		<Suspense fallback={<LayoutSplashScreen/>}>
			{/*<AlertProvider template={AlertTemplate}>*/}
			{/*	<AlertProvider*/}
			{/*		template={AlertTemplate}*/}
			{/*		position={positions.TOP_CENTER} //default position for all alerts without individual position*/}
			{/*		{...alert_options}*/}
			{/*	>*/}
					<Switch>
						{
							/* Redirect from root URL to /dashboard. */
							<Redirect exact from="/" to="/dashboard"/>
						}
						<ContentRoute path="/reset/password" component={ResetPassword}/>

						<ContentRoute path="/dashboard" component={DashboardPage}/>

						<ContentRoute path="/service/update" component={ServicesPage}/>
						<ContentRoute path="/service/modify" component={ServiceModifyPage}/>
						<ContentRoute path="/service" component={ServicesPage}/>

						<ContentRoute path="/plan" component={PlansPage}/>
						<ContentRoute path="/invoice" component={InvoicePage}/>

						<ContentRoute path="/record" component={RecordPage}/>

						<ContentRoute path="/library" exact component={LibraryPage}/>
						<ContentRoute path="/library/:fid-:name" exact component={LibraryPage}/>


						<ContentRoute path="/room/edit/:id" component={EditRoomPage}/>
						<ContentRoute path="/room/user/:id" component={AddUserToRoomPage}/>
						<ContentRoute path="/room/new" component={NewRoomPage}/>
						<ContentRoute path="/room/session/:rid/attendance/:sid" component={RoomAttendancePage}/>
						<ContentRoute path="/room/session/:rid" component={RoomSessionsPage}/>
						<ContentRoute path="/room" component={RoomsPage}/>

						<ContentRoute path="/user/edit/:id" component={EditUserPage}/>
						<ContentRoute path="/user/new" component={NewUserPage}/>
						<ContentRoute path="/user/import" component={ImportUserPage}/>
						<ContentRoute path="/user" component={UsersPage}/>


						<ContentRoute path="/session" component={SessionsPage}/>
						<ContentRoute path="/connection" component={ConnectionsPage}/>

						<ContentRoute path="/file/edit/:id" component={EditFilePage}/>
						<ContentRoute path="/file/new" component={NewFilePage}/>
						<ContentRoute path="/file" component={FilesPage}/>

						<ContentRoute path="/support" component={SupportsPage}/>
						<ContentRoute path="/faq" component={FAQPage}/>
						{/*<Route path="/user-profile" component={UserProfilepage} />*/}
						<Redirect to="/error/error-v1"/>
					</Switch>
			{/*	</AlertProvider>*/}
			{/*</AlertProvider>*/}
		</Suspense>
	);
}
